import { render } from "./App.vue?vue&type=template&id=c664211a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c664211a&lang=less&scoped=true"

import exportComponent from "F:\\luyou\\luyou_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c664211a"]])

export default __exports__